import formEntries from '../utils/form/entries';
import groupFormEntries from '../utils/form/groupFormEntries';
import type FormHandler from './FormHandler';

export interface IFormDataRetriever {
  getFormData: () => { [index: string]: any };
}

export default class DefaultFormDataRetriever implements IFormDataRetriever {
  formHandler: FormHandler;

  constructor(formHandler: FormHandler) {
    this.formHandler = formHandler;
  }

  getFormData = () => groupFormEntries(formEntries(this.formHandler.$form.elements));
}
